import React from "react"
import noDataImage from "./no-data.svg"


const Nodata = ({ height = "150px" }) => {
	return (
		<>
			<div
				style={{
					height: `${height}`,
					display: "flex",
					alignItems: "center",
					flexDirection: "column",
					justifyContent: "center",
				}}
			>
				<img src={noDataImage} alt="empty" height={80} objectFit="contain" />
				<div style={{ fontSize: "12px" }}>ไม่พบข้อมูล</div>
			</div>
		</>
	)
}

export default Nodata
